import { render, staticRenderFns } from "./PlayHuay.vue?vue&type=template&id=d239fb66&scoped=true&"
import script from "./PlayHuay.vue?vue&type=script&lang=js&"
export * from "./PlayHuay.vue?vue&type=script&lang=js&"
import style0 from "./PlayHuay.vue?vue&type=style&index=0&id=d239fb66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d239fb66",
  null
  
)

export default component.exports